var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4039",
    "data-name": "Group 4039",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4038",
    "data-name": "Group 4038",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8775",
    "data-name": "Path 8775",
    d: "M1.756,1.756a6,6,0,1,1,0,8.487,6,6,0,0,1,0-8.487m.637.637a5.1,5.1,0,1,0,7.214,0,5.1,5.1,0,0,0-7.214,0M5.365,6,3.879,7.485a.45.45,0,1,0,.637.637L6,6.636,7.488,8.122a.45.45,0,1,0,.636-.637L6.638,6,8.124,4.514a.45.45,0,1,0-.636-.637L6,5.363,4.516,3.877a.45.45,0,1,0-.637.637Z",
    transform: "translate(0 0)",
    fill: "#3f3f3f",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.8b3b98743228a5d34d8def0ff5691381.svg";
export { ForwardRef as ReactComponent };